import { DataSourceSearchResponseModel } from '@selfai-platform/bi-api';
import { SearchQueryResponse } from '../../associations';

export function normalizeSearchQueryApi(response: DataSourceSearchResponseModel): SearchQueryResponse {
  return {
    ...response,
  } as any;
}
